// extracted by mini-css-extract-plugin
export default {"learnmore":"styles_learnmore__dOFOK"};